import { render, staticRenderFns } from "./WidgetWrapperV2.vue?vue&type=template&id=391c1b8e&scoped=true&"
import script from "./WidgetWrapperV2.vue?vue&type=script&lang=js&"
export * from "./WidgetWrapperV2.vue?vue&type=script&lang=js&"
import style0 from "./WidgetWrapperV2.vue?vue&type=style&index=0&id=391c1b8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c1b8e",
  null
  
)

export default component.exports